import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { BusinessState } from '../business/business.types';
import MenuItem from 'material-ui/MenuItem';
import Drawer from 'material-ui/Drawer';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import Dvr from 'material-ui/svg-icons/device/dvr';
import CreditCard from 'material-ui/svg-icons/action/credit-card';
import Receipt from 'material-ui/svg-icons/action/receipt';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import 'material-ui/List';
import {
  isAttendancesDisabled,
  isProgramDisabled,
  isPaymentDisabled,
  isAccountDisabled,
  isItStaffAccount,
  isMemberDisabled,
  isPosDisabled,
  isPackageDisabled,
  isItClientAccount,
  isMarketingDisabled
} from '../util/permission.util';
import {
  M3_LOGO,
  SIDEBAR_HOVER_MEMBERS_ICON,
  SIDEBAR_HOVER_ATTENDANCES_ICON,
  SIDEBAR_HOVER_PROGRAMS_ICON,
  SIDEBAR_HOVER_PACKAGES_ICON,
  SIDEBAR_HOVER_MEMBERSHIP_PAYMENTS_ICON,
  SIDEBAR_HOVER_POS_ICON,
  SIDEBAR_HOVER_STAFF_ICON,
  SIDEBAR_HOVER_LIST_ICON,
  SIDEBAR_HOVER_HISTORY_ICON,
  SIDEBAR_HOVER_REPORT_ICON,
  SIDEBAR_HOVER_LEADS_ICON,
  SIDEBAR_HOVER_EMAIL_TEMPLATE_ICON,
  SIDEBAR_IDLE_MEMBERS_ICON,
  SIDEBAR_IDLE_ATTENDANCES_ICON,
  SIDEBAR_IDLE_PROGRAMS_ICON,
  SIDEBAR_IDLE_PACKAGES_ICON,
  SIDEBAR_IDLE_MEMBERSHIP_PAYMENTS_ICON,
  SIDEBAR_IDLE_POS_ICON,
  SIDEBAR_IDLE_STAFF_ICON,
  SIDEBAR_IDLE_LIST_ICON,
  SIDEBAR_IDLE_HISTORY_ICON,
  SIDEBAR_IDLE_REPORT_ICON,
  SIDEBAR_IDLE_LEADS_ICON,
  SIDEBAR_IDLE_EMAIL_TEMPLATE_ICON
} from './Constants';
import './sidebar.css';
import { SIDEBAR_MAX_WIDTH } from './Constants';
import List, { ListItem } from 'material-ui/List';
import { getBusinessLogoUrl } from 'src/util/image.util';

type Props = {
  readonly toDashboard: () => void
  readonly toPrograms: () => void
  readonly toMembers: () => void
  readonly toStaffs: () => void
  readonly toLeads: () => void
  readonly toAttendancesCheckIn: () => void
  readonly toAttendancesHistory: () => void
  readonly toBilling: () => void
  readonly toPaymentList: () => void
  readonly toPaymentHistory: () => void
  readonly toAdminDashboard: () => void
  readonly toAdminBusiness: () => void
  readonly toAdminAccountRegistration: () => void
  readonly toPosSale: () => void
  readonly toPosHistory: () => void
  readonly toAdminLockedAccount: () => void
  readonly toAdminEmailBlast: () => void
  readonly toPackages: () => void
  readonly toPackageReport: () => void
  readonly toEmailTemplate: () => void
  readonly toEmailResult: () => void
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly businessState: BusinessState
  readonly isMobile: boolean
  readonly open: boolean
  readonly toggleSidebarHandler: () => void
};

type States = {
  readonly attendanceMenuClicked: boolean
  readonly posMenuClicked: boolean
  readonly emailMenuClicked: boolean
  readonly paymentMenuClicked: boolean
  readonly accountInfoMenuClicked: boolean
  readonly packageMenuClicked: boolean
  readonly mouseOnMembersMenu: boolean
  readonly mouseOnAttendancesMenu: boolean
  readonly mouseOnAttendancesCheckInMenu: boolean
  readonly mouseOnAttendancesHistoryMenu: boolean
  readonly mouseOnProgramsMenu: boolean
  readonly mouseOnPackagesMenu: boolean
  readonly mouseOnPackagesListMenu: boolean
  readonly mouseOnPackagesReportMenu: boolean
  readonly mouseOnPaymentsMenu: boolean
  readonly mouseOnPaymentsListMenu: boolean
  readonly mouseOnPaymentsReportMenu: boolean
  readonly mouseOnPOSMenu: boolean
  readonly mouseOnPOSSaleMenu: boolean
  readonly mouseOnPOSHistoryMenu: boolean
  readonly mouseOnStaffsMenu: boolean
  readonly mouseOnLeadsMenu: boolean
  readonly mouseOnEmailTemplateMenu: boolean
};

class SidebarComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      attendanceMenuClicked: false,
      posMenuClicked: false,
      emailMenuClicked: false,
      paymentMenuClicked: false,
      accountInfoMenuClicked: false,
      packageMenuClicked: false,
      mouseOnMembersMenu: false,
      mouseOnAttendancesMenu: false,
      mouseOnAttendancesCheckInMenu: false,
      mouseOnAttendancesHistoryMenu: false,
      mouseOnProgramsMenu: false,
      mouseOnPackagesMenu: false,
      mouseOnPackagesListMenu: false,
      mouseOnPackagesReportMenu: false,
      mouseOnPaymentsMenu: false,
      mouseOnPaymentsListMenu: false,
      mouseOnPaymentsReportMenu: false,
      mouseOnPOSMenu: false,
      mouseOnPOSSaleMenu: false,
      mouseOnPOSHistoryMenu: false,
      mouseOnStaffsMenu: false,
      mouseOnLeadsMenu: false,
      mouseOnEmailTemplateMenu: false
    };
  }

  render() {
    const {
      authState,
      adminState,
      businessState,
      toDashboard,
      toAdminDashboard,
      isMobile,
      open,
      toggleSidebarHandler
    } = this.props;

    return (
      <Drawer
        docked={!isMobile}
        width={SIDEBAR_MAX_WIDTH}
        open={!isMobile || open}
        onRequestChange={toggleSidebarHandler}
        containerClassName="sidebar"
      >
        <img
          id="sidebar_m3_logo"
          src={businessState.business ?
            businessState.business.brandingAddOn ? getBusinessLogoUrl(businessState.business.picUrl) : M3_LOGO
            : M3_LOGO}
          onClick={() => {
            (isAdminAccount(authState) && !isImpersonating(adminState)) ?
              this.go(toAdminDashboard) :
              this.go(toDashboard);
          }}
          alt="M3_Logo"
          title="M3_Logo"
        />
        <hr
          style={
            {
              width: '80%',
              height: '1px',
              backgroundColor: '#B7B4AD',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: 0,
              marginBottom: 0
            }
          }
        />
        {
          isAdminAccount(authState) && !isImpersonating(adminState) ?
            this.renderAdminSidebarMenu() :
            isItStaffAccount(authState, adminState) ?
              this.renderStaffSidebarMenu() :
              this.renderClientSidebarMenu()
        }
      </Drawer>
    );
  }

  private renderClientSidebarMenu = (): JSX.Element => {
    return (
      <div>
        <List>
          {this.getMembersListItem()}
          {this.getAttendancesListItem()}
          {this.getProgramsListItem()}
          {this.getPackagesListItem()}
          {this.getPaymentsListItem()}
          {this.getPOSListItem()}
          {this.getStaffsListItem()}
          {this.getEmailTemplateListItem()}
        </List>
      </div>
    );
  }

  private renderStaffSidebarMenu = (): JSX.Element => {
    return (
      <div>
        <List>
          {this.getMembersListItem()}
          {this.getAttendancesListItem()}
          {this.getProgramsListItem()}
          {this.getPackagesListItem()}
          {this.getPaymentsListItem()}
          {this.getPOSListItem()}
          {this.getEmailTemplateListItem()}
        </List>
      </div>
    );
  }

  private renderAdminSidebarMenu = (): JSX.Element => {
    const {
      toAdminBusiness,
      toAdminAccountRegistration,
      toAdminLockedAccount,
      toAdminEmailBlast
    } = this.props;

    return (
      <div>
        <MenuItem
          key={1}
          onClick={() => this.go(toAdminBusiness)}
          className="sidebarMenuItem"
        >
          Business
        </MenuItem>
        <MenuItem
          key={2}
          onClick={() => this.go(toAdminAccountRegistration)}
          className="sidebarMenuItem"
        >
          Account<br />
          Registration
        </MenuItem>
        <MenuItem
          key={3}
          onClick={() => this.go(toAdminLockedAccount)}
          className="sidebarMenuItem"
        >
          Locked Account
        </MenuItem>
        <MenuItem
          key={4}
          onClick={() => this.go(toAdminEmailBlast)}
          className="sidebarMenuItem"
        >
          Email Blast
        </MenuItem>
      </div>
    );
  }

  private getMembersListItem = (): JSX.Element => {
    const {
      toMembers,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnMembersMenu ? <img src={SIDEBAR_HOVER_MEMBERS_ICON} /> :
          <img src={SIDEBAR_IDLE_MEMBERS_ICON} />}
        primaryText="Members"
        onClick={() => this.go(toMembers)}
        onMouseEnter={() => this.setState({ mouseOnMembersMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnMembersMenu: false })}
        disabled={isMemberDisabled(authState, adminState)}
        className={isMemberDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
      />
    );
  }

  private getAttendancesListItem = (): JSX.Element => {
    const {
      toAttendancesCheckIn,
      toAttendancesHistory,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnAttendancesMenu ? <img src={SIDEBAR_HOVER_ATTENDANCES_ICON} /> :
          <img src={SIDEBAR_IDLE_ATTENDANCES_ICON} />}
        primaryText="Attendances"
        disabled={isAttendancesDisabled(authState, adminState)}
        open={this.state.attendanceMenuClicked}
        onClick={() => this.state.attendanceMenuClicked ?
          this.setState({ attendanceMenuClicked: false, accountInfoMenuClicked: false })
          : this.setState({ attendanceMenuClicked: true, accountInfoMenuClicked: false })}
        onMouseEnter={() => this.setState({ mouseOnAttendancesMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnAttendancesMenu: false })}
        className={isAttendancesDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
        nestedItems={
          [
            <ListItem
              key={1}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnAttendancesCheckInMenu ? <img src={SIDEBAR_HOVER_ATTENDANCES_ICON} /> :
                <img src={SIDEBAR_IDLE_ATTENDANCES_ICON} />}
              primaryText="Check-In"
              onClick={() => this.go(toAttendancesCheckIn)}
              onMouseEnter={() => this.setState({ mouseOnAttendancesCheckInMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnAttendancesCheckInMenu: false })}
              disabled={isAttendancesDisabled(authState, adminState)}
              className={isAttendancesDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />,
            <ListItem
              key={2}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnAttendancesHistoryMenu ? <img src={SIDEBAR_HOVER_HISTORY_ICON} /> :
                <img src={SIDEBAR_IDLE_HISTORY_ICON} />}
              primaryText="History"
              onClick={() => this.go(toAttendancesHistory)}
              onMouseEnter={() => this.setState({ mouseOnAttendancesHistoryMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnAttendancesHistoryMenu: false })}
              disabled={isAttendancesDisabled(authState, adminState)}
              className={isAttendancesDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />
          ]

        }
      />
    );
  }

  private getProgramsListItem = (): JSX.Element => {
    const {
      toPrograms,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnProgramsMenu ? <img src={SIDEBAR_HOVER_PROGRAMS_ICON} /> :
          <img src={SIDEBAR_IDLE_PROGRAMS_ICON} />}
        primaryText="Programs"
        onClick={() => this.go(toPrograms)}
        onMouseEnter={() => this.setState({ mouseOnProgramsMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnProgramsMenu: false })}
        className={isProgramDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
      />
    );
  }

  private getPackagesListItem = (): JSX.Element => {
    const {
      toPackages,
      toPackageReport,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnPackagesMenu ? <img src={SIDEBAR_HOVER_PACKAGES_ICON} /> :
          <img src={SIDEBAR_IDLE_PACKAGES_ICON} />}
        primaryText="Packages"
        open={this.state.packageMenuClicked}
        onClick={() => this.state.packageMenuClicked ?
          this.setState({ packageMenuClicked: false, accountInfoMenuClicked: false })
          : this.setState({ packageMenuClicked: true, accountInfoMenuClicked: false })}
        onMouseEnter={() => this.setState({ mouseOnPackagesMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnPackagesMenu: false })}
        disabled={isPackageDisabled(authState, adminState)}
        className={isPackageDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
        nestedItems={
          [
            <ListItem
              key={1}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPackagesListMenu ? <img src={SIDEBAR_HOVER_LIST_ICON} /> :
                <img src={SIDEBAR_IDLE_LIST_ICON} />}
              primaryText="List"
              onClick={() => this.go(toPackages)}
              onMouseEnter={() => this.setState({ mouseOnPackagesListMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPackagesListMenu: false })}
              disabled={isPackageDisabled(authState, adminState)}
              className={isPackageDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />,
            <ListItem
              key={2}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPackagesReportMenu ? <img src={SIDEBAR_HOVER_REPORT_ICON} /> :
                <img src={SIDEBAR_IDLE_REPORT_ICON} />}
              primaryText="Report"
              onClick={() => this.go(toPackageReport)}
              onMouseEnter={() => this.setState({ mouseOnPackagesReportMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPackagesReportMenu: false })}
              disabled={isPackageDisabled(authState, adminState)}
              className={isPackageDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />
          ]
        }
      />
    );
  }

  private getPaymentsListItem = (): JSX.Element => {
    const {
      toPaymentList,
      toPaymentHistory,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnPaymentsMenu ? <img src={SIDEBAR_HOVER_MEMBERSHIP_PAYMENTS_ICON} /> :
          <img src={SIDEBAR_IDLE_MEMBERSHIP_PAYMENTS_ICON} />}
        open={this.state.paymentMenuClicked}
        onClick={() => this.state.paymentMenuClicked ?
          this.setState({ paymentMenuClicked: false, accountInfoMenuClicked: false })
          : this.setState({ paymentMenuClicked: true, accountInfoMenuClicked: false })}
        onMouseEnter={() => this.setState({ mouseOnPaymentsMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnPaymentsMenu: false })}
        primaryText="Payments"
        disabled={isPaymentDisabled(authState, adminState)}
        className={isPaymentDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
        nestedItems={
          [
            <ListItem
              key={1}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPaymentsListMenu ? <img src={SIDEBAR_HOVER_LIST_ICON} /> :
                <img src={SIDEBAR_IDLE_LIST_ICON} />}
              primaryText="List"
              onClick={() => this.go(toPaymentList)}
              onMouseEnter={() => this.setState({ mouseOnPaymentsListMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPaymentsListMenu: false })}
              disabled={isPaymentDisabled(authState, adminState)}
              className={isPaymentDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />,
            <ListItem
              key={2}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPaymentsReportMenu ? <img src={SIDEBAR_HOVER_REPORT_ICON} /> :
                <img src={SIDEBAR_IDLE_REPORT_ICON} />}
              primaryText="Report"
              onClick={() => this.go(toPaymentHistory)}
              onMouseEnter={() => this.setState({ mouseOnPaymentsReportMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPaymentsReportMenu: false })}
              disabled={isPaymentDisabled(authState, adminState)}
              className={isPaymentDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            />
          ]
        }
      />
    );
  }

  private getPOSListItem = (): JSX.Element => {
    const {
      toPosSale,
      toPosHistory,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnPOSMenu ? <img src={SIDEBAR_HOVER_POS_ICON} /> :
          <img src={SIDEBAR_IDLE_POS_ICON} />}
        open={this.state.posMenuClicked}
        onClick={() => this.state.posMenuClicked ?
          this.setState({ posMenuClicked: false, accountInfoMenuClicked: false })
          : this.setState({ posMenuClicked: true, accountInfoMenuClicked: false })}
        onMouseEnter={() => this.setState({ mouseOnPOSMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnPOSMenu: false })}
        primaryText="P.O.S."
        disabled={isPosDisabled(authState, adminState)}
        className={isPosDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
        nestedItems={
          [
            <ListItem
              key={1}
              className={isPosDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPOSSaleMenu ? <img src={SIDEBAR_HOVER_POS_ICON} /> :
                <img src={SIDEBAR_IDLE_POS_ICON} />}
              primaryText="Sale"
              onClick={() => this.go(toPosSale)}
              onMouseEnter={() => this.setState({ mouseOnPOSSaleMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPOSSaleMenu: false })}
              disabled={isPosDisabled(authState, adminState)}
            />,
            <ListItem
              key={2}
              className={isPosDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
              hoverColor="#6d6e71"
              leftIcon={this.state.mouseOnPOSHistoryMenu ? <img src={SIDEBAR_HOVER_HISTORY_ICON} /> :
                <img src={SIDEBAR_IDLE_HISTORY_ICON} />}
              primaryText="History"
              onClick={() => this.go(toPosHistory)}
              onMouseEnter={() => this.setState({ mouseOnPOSHistoryMenu: true })}
              onMouseLeave={() => this.setState({ mouseOnPOSHistoryMenu: false })}
              disabled={isPosDisabled(authState, adminState)}
            />
          ]
        }
      />
    );
  }

  private getStaffsListItem = (): JSX.Element => {
    const {
      toStaffs,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        className="sidebarListItem"
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnStaffsMenu ? <img src={SIDEBAR_HOVER_STAFF_ICON} /> :
          <img src={SIDEBAR_IDLE_STAFF_ICON} />}
        primaryText="Staffs"
        onClick={() => this.go(toStaffs)}
        onMouseEnter={() => this.setState({ mouseOnStaffsMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnStaffsMenu: false })}
      />
    );
  }

  private getLeadsListItem = (): JSX.Element => {
    const {
      toLeads,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        className="sidebarListItem"
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnLeadsMenu ? <img src={SIDEBAR_HOVER_LEADS_ICON} /> :
          <img src={SIDEBAR_IDLE_LEADS_ICON} />}
        primaryText="Leads"
        onClick={() => this.go(toLeads)}
        onMouseEnter={() => this.setState({ mouseOnLeadsMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnLeadsMenu: false })}
      />
    );
  }

  private getEmailTemplateListItem = (): JSX.Element => {
    const {
      toEmailTemplate,
      toEmailResult,
      authState,
      adminState
    } = this.props;
    return (
      <ListItem
        hoverColor="#5E5A5A"
        leftIcon={this.state.mouseOnEmailTemplateMenu ? <img src={SIDEBAR_HOVER_EMAIL_TEMPLATE_ICON} /> :
          <img src={SIDEBAR_IDLE_EMAIL_TEMPLATE_ICON} />}
        primaryText="Email"
        onMouseEnter={() => this.setState({ mouseOnEmailTemplateMenu: true })}
        onMouseLeave={() => this.setState({ mouseOnEmailTemplateMenu: false })}
        disabled={isMarketingDisabled(authState, adminState)}
        className={isMarketingDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
        nestedItems={[
          <ListItem
            key={1}
            className={isPosDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            hoverColor="#6d6e71"
            leftIcon={this.state.mouseOnPOSSaleMenu ? <img src={SIDEBAR_HOVER_POS_ICON} /> :
              <img src={SIDEBAR_IDLE_POS_ICON} />}
            primaryText="Templates"
            onClick={() => this.go(toEmailTemplate)}
            onMouseEnter={() => this.setState({ mouseOnEmailTemplateMenu: true })}
            onMouseLeave={() => this.setState({ mouseOnEmailTemplateMenu: false })}
            disabled={isPosDisabled(authState, adminState)}
          />,
          <ListItem
            key={2}
            className={isPosDisabled(authState, adminState) ? 'sidebarListItemDisabled' : 'sidebarListItem'}
            hoverColor="#6d6e71"
            leftIcon={this.state.mouseOnPOSHistoryMenu ? <img src={SIDEBAR_HOVER_HISTORY_ICON} /> :
              <img src={SIDEBAR_IDLE_HISTORY_ICON} />}
            primaryText="Results"
            onClick={() => this.go(toEmailResult)}
            onMouseEnter={() => this.setState({ mouseOnEmailTemplateMenu: true })}
            onMouseLeave={() => this.setState({ mouseOnEmailTemplateMenu: false })}
            disabled={isMarketingDisabled(authState, adminState)}
          />
        ]}
      />
    );
  }

  private go = (path: () => void): void => {
    path();
  }
}

export default SidebarComponent;



// WEBPACK FOOTER //
// ./src/navigation/SidebarComponent.tsx